export const basePath = 'api/tags'

export interface Item {
  id: number;
  name: string;
  system: number;
}

export interface ModuleState {
  error: boolean;
  items: Item[];
}